import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import Gallery from "../../components/Gallery/Gallery";
import CTAOne from "../../components/CTA/CTAOne";
import buyerpdf from '../../assets/images/Buyer Broker Advisory Services 2025.pdf'; // importing image



const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef(); 
  const rentals = useRef();
  const contact = useRef();

  const scrollToSection = (e, content) => {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
          break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className=" mt-minus-50">
        <div className="container mt-minus-50">
      <div className="row mt-minus-50">
        <HeadingSection
       
          classAppend="dark-color"
        > <h2>INFORMATION FOR BUYERS</h2></HeadingSection>
      </div>
     
<h3>CHANGES IN DISCLOSURE FOR BUYERS OF U.S. REAL ESTATE 2024-2025</h3>
<p>In November 2024, a landmark anti-trust case in Missouri against the National Association of Realtors forced changes in the industry in terms of disclosure of representation and disclosure of commissions or fees charged by brokers. As a result, all agents who are members of the National Association of Realtors (NAR) and their Multiple Listing Services (MLS) are required to provide a Buyer’s Broker Agreement. A buyer who does not have a signed buyer’s broker agreement is considered unrepresented. </p>
<br />
<p><img width="400" src={require("../../assets/images/press/nyt.png")} ></img></p>
<h5>Judge Approves Settlement That Changes Rules for Real Estate Agents Following a lawsuit, the National Association of Realtors was ordered to rewrite its rules governing agents’ commissions and pay $418 million in damages.  </h5>
<p><a href="https://www.nytimes.com/2024/11/26/realestate/nar-settlement-approval- commissions.html ">https://www.nytimes.com/2024/11/26/realestate/nar-settlement-approval- commissions.html</a></p>

<br />
<p><h3>OLSHAN BUYER BROKER ADVISORY SERVICES </h3>
<p>Since 1980, Olshan Realty Inc. has prided itself on being a fullservice
residential brokerage firm with experienced agents
who provide a high level of service that employs technology,
research and data analytics. </p>
<p>The Buyer Broker Advisory Services utilizes an array of tools
and research to help the buyer find a home and make a solid
business decision.</p>

<br />

<h4>Your Personal Algorithm</h4>
<p>Each buyer has specific algorithms set in Olshan’s private database to
search for appropriate properties with parameters that include price,
neighborhood, financing, pets, floor height, outdoor space and
amenities, which include doormen, fitness center, pool, garage and
more. There are over 100 fields that can be tapped to provide a high quality
search that targets appropriate properties and saves the buyer
time. Each algorithm is updated in real time to provide a list of new
properties as well as changes in status like price drops, contracts
signed, and open houses. Olshan brokers are skilled technicians with a
comprehensive database of thousands of sales, rentals, townhouse
and building listings. The database allows buyer brokers to share
folders of properties with their clients.</p>
<p><img src={require("../../assets/images/algorithm.jpg")} ></img></p>

</p>


<br />
<p><h3>BUYER CUSTOM RESEARCH REPORTS </h3>
<h4>Here’s what you can expect from our various reports:</h4>

<p>
1. Custom Search of Active Inventory, Contracts Signed and Closed Reports of similar
properties help the buyer evaluate the correct sales or rental price.<br />
2. ACRIS: A website where NYC records deeds, ownership, price and date of closing.<br />
3. NYC Department of Finance: A website that confirms square footage and taxes.<br />
4. New York City Department of Buildings (DOB): Information needs to be obtained early in
the process on open and closed building permits. Buyers are advised against closing on a
property with open building permits. Research on the building, problems, certificate of
occupancy, and fines levied by the NYC Department of Buildings need to be evaluated.
Sometimes an expeditor needs to be retained by the seller to close open permits.<br />
5. Litigation Search: Investigating public databases to see if the unit or building is
encumbered by litigation.<br />
6. Zoning Issues.<br />
7. Sight Line: How the view will be impacted; for example, a planned new building
that could obstruct the view.<br />
8. Landmark District: Analysis of whether a property is in a Landmark district and
how that will impact renovation or construction.</p>

</p>

<br />

<p><h3>Floorplan Review</h3>
<h4>Advising on floorplans for furniture placement and changes that can be made to unlock value.</h4>
<p>Park Avenue Prewar 6-Room</p>
<p><img src={require("../../assets/images/floorplan.jpg")} ></img></p>

</p>

<br />
<p><h3>FINANCIAL ANALYSIS and DOCUMENT REVIEW </h3>


<p>
1. Financial analysis of the Building:
Review of the last 3 years.<br />
2. Review of House Rules and Bylaws.<br />
3. Review of the Offering Plan and
Amendments.<br />
4. Review of the Building Alteration
Agreement, which can significantly
impact the cost and duration of
construction. Most buildings have a limit
on the number of renovation days and
levies fines on owners that exceed a
certain number of days. These fines can
add up to tens of thousands of dollars.</p>

</p>


<br />
<p><h3>BUYER NEGOTIATION</h3>


<p>
Negotiation is a skill and art. As a Buyer’s
Broker, our job is to negotiate the best
possible price and terms for a buyer. To be
effective, we help our buyers organize bios,
financial information and pre-approval
mortgage documents so that the sellers can
feel comfortable when negotiating with the
buyer. Part of the negotiation might involve
price concessions for the flip tax,
assessments and renovation expenses.
Negotiations in new construction can
involve developer/sponsor concessions for
monthly common charges and closing costs
that might include city and state recording
taxes, sponsor attorney’s fees and a portion
of the price of the resident manager’s unit.
Closing costs in new construction can total
hundreds of thousands or, at the uber-price
level, millions of dollars.
</p>

</p>


<br />
<p><h3>BUYER CLOSING COSTS REVIEW</h3>


<p>
Closing costs can be expensive, and it is very important
to evaluate such costs as they pertain to a particular
property and price range; for example, condos have
different closing costs than co-ops.
</p>

</p>


<br />
<p><h3>MORTGAGE PROCESS--AN INDEPENDENT REVIEW</h3>


<p>
Olshan Realty Inc. is NOT affiliated with any lender or title company and can help a
Buyer independently evaluate different financing opportunities. A Buyer’s Broker can also
help determine if a building has been pre-approved for mortgage financing.
</p>

</p>


<br />
<p><h3>CO-OP AND CONDO BOARD APPLICATION PROCESS</h3>


<p>
Olshan's agents are highly experienced in preparing co-op and condo applications and
counseling on the co-op board interview process. These labor-intensive applications
require a mastery in how to best present a buyer. Information required includes typed
applications, credit reports, bank and brokerage statements, personal and business letters
of reference, employer letters, a CPA letter and full sets of 1040 tax returns. Often, condo
board applications mimic co-op board applications and similar information is requested.
In the end, hundreds of pages are assembled, requiring serious attention to detail. A
shoddy co-op board package can result in a co-op board rejection.
</p>

</p>


<br />
<p><h3>TOWNHOUSES</h3>

<p><img src={require("../../assets/images/townhouses.jpg")} ></img></p>
<p>
Townhouses are a special sector of the NYC market and are evaluated based on location, width
of the house, amount of square footage, room for expansion (adding extra square-footage)
and overall condition. The size of the garden, outdoor space and view can also affect value.
It is important to have a Buyer’s Broker provide information on whether the townhouse is in
a Landmark area or district, along with accurate comparable sales information with context.
Many of the townhouses are over 100 years old and require extensive work but offer large
square footage, interesting architectural details, and outdoor space.
</p>

</p>



<br />
<p><h3>SINGLE FAMILY HOUSES</h3>

<p><img src={require("../../assets/images/singlefamily.jpg")} ></img></p>
<p>
Olshan Group LLC, an affiliate of Olshan Realty Inc., is a
member of the Hudson Gateway Association of Realtors
(HGAR) and its OneKey MLS database that has thousands of
listings in Manhattan, Westchester, Long Island, Rockland,
Putnam, Dutchess, Orange, Ulster and Sullivan Counties.
OneKey MLS has 45,000 members and is an invaluable
source for many locales and types of housing.
</p>

</p>


<br />
<p><h3>ATTORNEY REVIEW</h3>


<p>
Olshan has a list of attorneys that it can recommend based
on the needs of the client.
</p>

</p>



<br />
<p><h3>VENDOR, ARCHITECT AND CONSTRUCTION SERVICES</h3>


<p>
Olshan maintains a list of architects, contractors, painters, and other vendors to improve,
renovate or cosmetically alter a home. With a huge number of resources in the design and
construction fields, Olshan is in the position to help a buyer navigate a complex sector.
</p>

</p>


<br />
<p><h3>HOME INSPECTION</h3>


<p>
As a Buyer’s Broker, we often recommend that a home inspector
or engineer evaluate the property even though structural
defects are the responsibility of the co-op or condo. The Buyer’s
Broker Advisory Services will advise what specialist to retain
including in some cases an environmental inspection for mold
and air quality. Home inspections outside of New York City
often involve a septic inspection, well inspection, water testing,
radon inspections, termite inspections and an assessment of
environmental issues like buried oil tanks or flooding.
</p>

</p>


<br />
<p><h3>NEIGHBORHOOD SERVICES</h3>


<p>

Olshan advises on the neighborhood services, transportation, and conveniences that each
area offers.
</p>

</p>



<br />
<p><h3>NEW CONSTRUCTION</h3>


<p>
New construction often involves purchasing off
floorplans or buying in a building before it has been
completed. Floorplans need to be evaluated but the
buyer needs to be advised on the sponsor reputation,
the quality of construction, where the unit sits in the
building and the probability that the project will be
completed in the way that the building was marketed.
Offering plan and amendments need to be reviewed--
particularly the "Risk Section" in the offering plan.
Sponsors try to pass on all closing costs to buyers.
</p>
<p>Closing costs can run into hundreds of thousands or
millions of dollars depending on the price point.
Closing costs should be negotiated when possible.

</p>

</p>

<br />
<p><h3>LUXURY PROPERTIES</h3>


<p>
Olshan Realty Inc. is known for the weekly Olshan Report, published every Monday
morning at 7:15AM. The report covers all the contracts signed in Manhattan at $4 million
and above. It is considered a must read--the go-to report in NYC luxury real estate--and
is frequently quoted in the <i>Wall Street Journal, The Real Deal, NYTimes, NY Post, Crain’s</i>
and <i>Architectural Digest</i>, among others.
<p>Olshan has a comprehensive database of luxury stats going back to 2006. It can spot
trends, making Olshan Realty a leader in the field of luxury properties.</p>
</p>
<p><img src={require("../../assets/images/luxuryprops.jpg")} ></img></p>
</p>

<br />
<p><h3>THE WALK-THROUGH AND CLOSING</h3>


<p>

The walk-through can be an uncomfortable part of purchasing a home. A Buyer’s Broker
needs to be present for the walk-through of the property before closing and advise on the
items that need to be fixed or if a credit should be provided by the seller at closing. A
Buyer’s Broker is a necessity in new construction because too often sponsors try to close
without completely finishing the unit, resulting in an extensive post-closing punch list.

</p>

</p>


    </div>
    
    </section>

    
    <Gallery
        title="MORE FEATURED PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={sales}
      />

      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />

<CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan publishes a report covering all the contract activity in the luxury market on properties at $4 million and above. The free report draws subscribers from all over the world, and is frequently quoted in the New York Times, Wall Street Journal, Crain's, Observer, The Real Deal and various media outlets. 
      </CTAOne>
      <FooterOne />
    </Loader>
  );
};



export default Architecture;
